<template>
    <div>
        <h1 class="text-center mt-4">Get in touch with us now!</h1>
        <h3 class="text-center">Learn the secrets</h3>
        <p class="text-center">Please email us today in order to learn all of the secrets that you need to win both WarioWare Cat Game and WarioWare Chinese Crawling Championship Game.</p>
        <p class="text-center">Click below to email us directly, and we will be happy to share our secrets!</p>

        <b-btn variant="primary" class="mb-4" href="mailto:winwariowarcatgame@gmail.com">Email Us Now</b-btn>

        <img class="w-100" :src="require('../assets/finalboss.jpg')">
    </div>
</template>

<script>
export default {

}
</script>

<style scoped>

</style>
